import React, { useState, useEffect } from 'react'
import { Box, Button, Checkbox, FormControlLabel, Paper, Radio, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import Modal from '../../../../common/modal'
import { Item } from '../../../../common/snippets'
import DropDownOA from '../../../../common/dropDownOA'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import Lineinput from '../../../../common/lineinput'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import { paymentModesWithAll } from '../../../../common/paymentsMode'
import { getBookingConsType, getGSBranchValuationDetailsTableData, getGSInsuranceInsertUpadate } from '../../../../../store/generalSetting/GSAction'
import { useTranslation } from '../../../../../i18n/I18nProvider'


const CreateEditValuationChrge = (props) => {
  const {DefaultCurrencyID, data, updateModal, isEdit, editTableData, getGSInsuranceInsertUpadate, updateAlertError, getGSBranchValuationDetailsTableData } = props
  const { common, generalSettingReducer, } = data
  const { loginData, citywiseBranchList } = { ...common }
  const { gsValuationChargeEditData, bookingConsType } = generalSettingReducer
  const { translations, language } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const [editModelRows, setEditModelRows] = useState([{ GoodsValueFrom: 1, GoodsValueTo: 1000000000, PerAmount: 1, Rate: 0 }])
  const [selConsType, setSelConsType] = useState('')
  const [consTypeOpt, setConsTypeOpt] = useState([])
  const [totalUnitCheck, setTotalUnitCheck] = useState(false)
  const [valuationChrg, setValuationChrg] = useState("")
  const [addiValuationChrg, setAddiValuationChrg] = useState("")
  const [isActive, setIsActive] = useState(false)
  const [allBranchCheck, setAllBranchCheck] = useState(false)
  const [declaredValueCheck, setDeclaredValueCheck] = useState(false)
  const [selectedBranch, setSelectedBranch] = useState()
  const [selectedPayType, setSelectedPayType] = useState()
  const [successModal, setSuccessModal] = useState(false)
  const [isUpdate, setIsUpdate] = useState(false)
  useEffect(() => {
    if (bookingConsType?.length > 0) {
      const data = [{ SubType: tr('gsAll', 'All'), ConsignmentSubTypeID: 0 }, ...bookingConsType]
      setConsTypeOpt(
        removeDuplicatesFromArray(
          data.map((val, i) => ({ ...val, SubType: val.SubType.trim() })),
          'ConsignmentSubTypeID'
        )
      )
      // setTableData(bookingConsType)
      if (editTableData !== '') {
        setSelConsType((prev) =>
          prev?.ConsignmentSubTypeID === 0 ? data[0] : prev
        )
      } else {
        setSelConsType((prev) =>
          data.find((item) => item.ConsignmentSubTypeID === prev?.ConsignmentSubTypeID) || data[0]
        )
      }


    } else {
      setConsTypeOpt([])
      // setTableData([])
      setSelConsType('')
    }
  }, [bookingConsType, translations])
  useEffect(() => {
    if (editTableData !== '' && isEdit) {
      setSelectedBranch({ BranchID: editTableData.BranchId, BranchName: editTableData.BranchName })
      setSelectedPayType({ typeId: editTableData.PaymentTypeID, name: editTableData.PaymentType })
      // setSelectedPayType(paymentModesWithAll.filter((val) => val.typeId == editTableData.PaymentTypeID)?.[0])
      // setSelConsType(bookingConsType.filter((val) => val.ConsignmentSubTypeID == editTableData.ConsignmentSubTypeId)?.[0])
      setSelConsType({
        ConsignmentSubTypeID: editTableData?.ConsignmentSubTypeId,
        SubType: editTableData?.ConsignmentSubTypeId === 0 ? tr('gsAll', 'All') : editTableData?.SubType
      })
      setValuationChrg(gsValuationChargeEditData.Table?.[0]?.UnitCharge)
      setAddiValuationChrg(gsValuationChargeEditData.Table?.[0]?.AdditionalUnitCharges)
      if (gsValuationChargeEditData?.Table?.length > 0) {
        setDeclaredValueCheck(gsValuationChargeEditData?.Table?.[0]?.IsValOnDeclaredVal === 1 ? true : false)
        setTotalUnitCheck(gsValuationChargeEditData?.Table?.[0]?.IsValOnTotalUnits === 1 ? true : false)
      }
      setIsActive(editTableData.IsActive === 1 ? true : false)
      const data = gsValuationChargeEditData.Table?.map((val, i) => ({ GoodsValueFrom: i == 0 ? 1 : gsValuationChargeEditData?.Table[i - 1]?.MinGoodsValue + 1, GoodsValueTo: val.MinGoodsValue, PerAmount: val.Percentage==0 && val.Amount==0?1:val.Percentage!==0?1:2, Rate:val.Percentage==0 && val.Amount==0?0:val.Percentage!==0?val.Percentage:val.Amount }))
      setEditModelRows(data)
    }
  }, [editTableData, gsValuationChargeEditData])

  useEffect(() => {
    // addNewValuationCharge();focusElemnt('selectBranch')
    focusElemnt('selectBranch')
  }, [])
  // getGSInsuranceInsertUpadate
  const saveValuationCharge = () => {
    // focusElemnt('addValChargeBtn')
    setIsUpdate(true)
    const obj = {
      CompanyID: loginData?.intCompanyID,
      BranchID:allBranchCheck===true?0:selectedBranch?.BranchID,
      UserID: loginData?.intUserID,
      ConsignmentSubTypeID: selConsType?.ConsignmentSubTypeID,
      PaymentType: selectedPayType?.typeId,
      MinGoodsValue1: editModelRows?.length >= 1 ? editModelRows[0]?.GoodsValueTo : 0,
      AmountValue1: editModelRows?.length >= 1 ? editModelRows[0]?.PerAmount == 2 ? Number(editModelRows[0]?.Rate) : 0 : 0,
      PctValue1: editModelRows?.length >= 1 ? editModelRows[0]?.PerAmount == 1 ? Number(editModelRows[0]?.Rate) : 0 : 0,
      MinGoodsValue2: editModelRows?.length >= 2 ? editModelRows[1]?.GoodsValueTo : 0,
      AmountValue2: editModelRows?.length >= 2 ? editModelRows[1]?.PerAmount == 2 ? Number(editModelRows[1]?.Rate) : 0 : 0,
      PctValue2: editModelRows?.length >= 2 ? editModelRows[1]?.PerAmount == 1 ? Number(editModelRows[1]?.Rate) : 0 : 0,
      MinGoodsValue3: editModelRows?.length >= 3 ? editModelRows[2]?.GoodsValueTo : 0,
      AmountValue3: editModelRows?.length >= 3 ? editModelRows[2]?.PerAmount == 2 ? Number(editModelRows[2]?.Rate) : 0 : 0,
      PctValue3: editModelRows?.length >= 3 ? editModelRows[2]?.PerAmount == 1 ? Number(editModelRows[2]?.Rate) : 0 : 0,
      AdditionalUnitCharges: Number(addiValuationChrg) || 0,
      UnitCharge: Number(valuationChrg) || 0,
      IsActive: isActive ? 1 : 0,
      IsValOnDeclaredValue: declaredValueCheck ? 1 : 0,
      IsValOnTotalUnits: totalUnitCheck ? 1 : 0
    }
    getGSInsuranceInsertUpadate(obj).then((res) => {
      if (res?.status == 'Success') {
        setSuccessModal(true)
      } else {
        updateAlertError({ show: true, msg: res.Message, nextId: 'GSValuation_Type' })
      }
    }).catch((err) => {
      console.log("Error:", err)
    })
  }
  const handleRadioChange = (type, index) => {
    let updatedRows = [...editModelRows]
    if (index >= 0 && index <= updatedRows.length) {
      if (type === 'Percentage') {
        updatedRows[index].PerAmount = 1
      } else if (type === 'Amount') {
        updatedRows[index].PerAmount = 2
      }
      if (editTableData !== "" && isEdit) {
        if (type === 'Percentage') {
          updatedRows[index].Rate = gsValuationChargeEditData.Table?.[index]?.Percentage
        } else if (type === 'Amount') {
          updatedRows[index].Rate = gsValuationChargeEditData.Table?.[index]?.Amount
        }
      }
      setEditModelRows(updatedRows)
    }
  }
  const handleChangeRate = (e, index) => {
    let updatedRows = [...editModelRows]
    if (index >= 0 && index <= updatedRows.length) {
      updatedRows[index].Rate = e.target.value
      setEditModelRows(updatedRows)
    }
  }
  const handleChangeGoodsValue = (e, index) => {
    let updatedRows = [...editModelRows]
    if (index >= 0 && index <= updatedRows.length) {
      // Update the GoodsValueTo property of the previous row (index)
      updatedRows[index].GoodsValueFrom = e.target.value
      updatedRows[index - 1].GoodsValueTo = e.target.value - 1
      setEditModelRows(updatedRows)
    }
  }
  const addRow = (index) => {
    let newData = { GoodsValueFrom: '', GoodsValueTo: editModelRows[index].GoodsValueTo, Rate: 0, PerAmount: 1 }
    let newArr = [...editModelRows.map((val, i) => (i === index ? { ...val, GoodsValueTo: '' } : val))]
    newArr.splice(index + 1, 0, newData)
    setEditModelRows(newArr)
    focusElemnt(`valueFrom-${index + 1}`)
  }
  const removeRow = (index) => {
    let oldValue = editModelRows[index].GoodsValueTo
    let newArr = editModelRows.filter((val, i) => i !== index)
    setEditModelRows([...newArr.map((val, i) => (i === index - 1 ? { ...val, GoodsValueTo: oldValue } : val))])
    focusElemnt(`docValue-${index - 1}`)
  }
  const modalClose = () => {
    if (!isEmpty(loginData)) {
      const obj = {
        CompanyID: loginData?.intCompanyID,
      }
      getGSBranchValuationDetailsTableData(obj)
    }
    updateModal(false, 'ADDVALUATIONCHARGE')
    updateModal(false, 'VALUATIONCHARGE')
    focusElemnt('addValChargeBtn')
  }
  // const handleCheckGoodsValue=(val,index)=>{
  //   console.log("first",val.target.value)
  // }
  const handleCheckGoodsValue = (event, field, index) => {
    if (field === 'GoodsValueTo' && isEdit && parseInt(event.target.value) > 9999999) {
      updateAlertError({ show: true, msg: tr('gsToNopMax', 'GoodsValueTo value should not exceed 9999999'), nextId: `ToNOP-${index}` })
      resetValuationChrg(event, field, index)
    } else if (field === 'GoodsValueTo' && isEdit && event.target.value !== '' && (event.target.value !== '' ? parseInt(event.target.value) <= editModelRows[index].GoodsValueFrom : true)) {
      updateAlertError({ show: true, msg: tr('gsToNopGt', 'GoodsValueTo value should greater than FromNOP'), nextId: `ToNOP-${index}` })
      resetValuationChrg(event, field, index)
    } else if (field === 'GoodsValueFrom' && event.target.value !== '') {
      if (parseInt(event.target.value) <= editModelRows[index - 1].GoodsValueFrom) {
        updateAlertError({ show: true, msg: tr('gsGtPrev', 'Value must be greater than previous value'), nextId: `FromNOP-${index}` })
        resetValuationChrg(event, field, index)
      } else if ((editModelRows.length - 1) > index ? editModelRows[index + 1]?.GoodsValueFrom !== "" ? parseInt(event.target.value) >= editModelRows[index + 1]?.GoodsValueFrom : false : false) {
        updateAlertError({ show: true, msg: tr('gsLtNext', 'Value must be less than next value'), nextId: `FromNOP-${index}` })
        resetValuationChrg(event, field, index)
      } else if (parseInt(event.target.value) >= 9999999) {
        updateAlertError({ show: true, msg: tr('gsNopFromMax', 'GoodsValueFrom should not exceed 9999999'), nextId: `FromNOP-${index}`})
        resetValuationChrg(event, field, index)
      } else if (isEdit && (index === 3 && editModelRows[index].GoodsValueTo !== "" ? parseInt(event.target.value) > editModelRows[index].GoodsValueTo : false)) {
        updateAlertError({ show: true, msg: tr('gsLtToNop', 'Value must be less than GoodsValueTo value'), nextId: `FromNOP-${index}` })
        resetValuationChrg(event, field, index)
      }
    }
  }
  const resetValuationChrg = (event, field, index) => {
    let oldData = [...editModelRows.map((val, i) => i === index ? { ...val, [field]: "" } : val)];
    if (field === 'GoodsValueFrom') {
      oldData[index - 1].GoodsValueTo = ""
    }
    setEditModelRows(oldData)
  }
  const onChangeHandle=(e)=>{
    if (e.target.checked==false) {
      const rateValue=editModelRows?.map((val)=>({...val,Rate:0}))
      setEditModelRows(rateValue)
    }
    setDeclaredValueCheck(!declaredValueCheck)
  }
  const handleTotalUnitCheck=(e)=>{
    if (e.target.checked==false) {
      setValuationChrg('')
      setAddiValuationChrg('')
    }
    setTotalUnitCheck(!totalUnitCheck)
  }
  return (
    <>
      <Modal headTxt={isUpdate ? tr('successModel', 'Success Model') : isEdit ? DefaultCurrencyID ===2?tr('editInsuranceCharge', 'Edit Insurance Charge'):tr('editValuationCharge', 'Edit Valuation Charge') : DefaultCurrencyID ===2?tr('addInsuranceCharge', 'Add Insurance Charge'):tr('addValuationCharge', 'Add Valuation Charge')} width={successModal ? '25%' : '60%'} updateModal={updateModal} sx={{ marginTop: '20px' }}>
        {
          successModal ? <>
            <Stack>
              <Box style={{ margin: '10px', fontSize: '17px' }}>
                {isEdit ? <div> {tr('valuationChargeUpdated', 'Valuation Charge Updated!')}</div> : <div> {tr('valuationChargeCreated', 'Valuation Charge Created!')}</div>}
              </Box>
            </Stack>
            <Stack>
              <div className="modal-btn-grp" style={{ marginRight: '10px' }}>
                <button
                  id='okBtn'
                  autoFocus={true}
                  style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px' }}
                  onClick={() => modalClose()}
                // onKeyDown={(e) => {navigation3(e, `docIditBtn-0`, 'docActiveCheckBox', () => {})}}
                >
                  {tr('gsOk', 'Ok')}
                </button>
              </div>
            </Stack>

          </> : <>
            <Stack style={{ width: '100%', padding: "24px 16px 0px 16px", }}>
              <Box style={{ display: 'flex', width: '100%', gap: '14px' }}>
                {/* <Grid> */}
                <Item style={{ width: '34%', padding: '0px' }}>
                  <DropDownOA
                    disabled={isEdit}
                    id={'selectBranch'}
                    defaultvalue={selectedBranch?.BranchName}
                    data={citywiseBranchList || []}
                    width="100%"
                    searchPlaceholder={tr('searchBranch', 'Search Branch')}
                    label={tr('selectBranch', 'Select Branch')}
                    // tabIndex="2"
                    dataKey={`BranchName`}
                    idKey={`BranchID`}
                    onSelect={(val) => setSelectedBranch(val)}
                    nextId={"GSBConsignment_Type"}
                    prevId={"selectBranch"}
                  />
                </Item>
                <Item style={{ width: '33%', padding: '0px' }}>
                  <DropDownOA
                    key={`GSBConsignment_Type-${language}-${selConsType?.SubType}`}
                    disabled={isEdit}
                    id={'GSBConsignment_Type'}
                    label={tr('consignmentType', 'Consignment Type')}
                    searchPlaceholder={tr('searchConsignmentType', 'Search Consignment Type')}
                    defaultvalue={selConsType?.SubType || selConsType}
                    value={selConsType?.SubType || selConsType}
                    data={consTypeOpt || []}
                    listWidth="230px"
                    width="100%"
                    dataKey={`SubType`}
                    idKey={`ConsignmentSubTypeID`}
                    onSelect={(obj) => setSelConsType(obj)}
                    nextId={'paymentBookingType'}
                    prevId={'selectBranch'}
                  />
                </Item>
                <Item style={{ width: '33%', padding: '0px' }} >
                  <DropDownOA
                    disabled={isEdit}
                    id="paymentBookingType"
                    label={tr('gsPayType', 'Payment Type')}
                    // isObjArr={true}
                    searchPlaceholder={tr('searchPaymentType', 'Search Payment Type')}
                    onSelect={(val) => setSelectedPayType(val)}
                    data={paymentModesWithAll.filter((val) => val.typeId !== 0) || []}
                    dataKey={`name`}
                    idKey={`typeId`}
                    tabIndex="2"
                    defaultvalue={selectedPayType?.name}
                    nextId={'checkValBasedValue'}
                    prevId={'GSBConsignment_Type'}
                    width="100%"
                  />
                </Item>
              </Box>
            </Stack>
            <Item style={{ width: '100%', }}>
              <Item className="checkbox-ctrl">
                <FormControlLabel
                  value="end"
                  onChange={(e) => onChangeHandle(e)}
                  // onChange={() => setDeclaredValueCheck(!declaredValueCheck)}
                  control={
                    <Checkbox
                      id="checkValBasedValue"
                      checked={declaredValueCheck}
                      // sx={{ marginLeft: '8px' }}
                      onKeyDown={(e) => navigation3(e, `valueFrom-0`, "paymentBookingType")}
                    />
                  }
                  // label="Consigner"
                  label={
                    <span style={{ fontSize: '14px', fontWeight: '700', fontStyle: 'normal', lineHeight: '20px', color: '#444' }}>
                      {DefaultCurrencyID ===2?tr('insuranceBasedOnDeclared', 'Insurance Based on Declared Value'):tr('valuationBasedOnDeclared', 'Valuation Based on Declared Value')}
                    </span>
                  }
                  labelPlacement="end"
                />
              </Item>
            </Item>
            <Stack style={{ width: '100%', padding: "0px 16px" }}>
              <TableContainer component={Paper}>
                <Table className="scroll" size="small" aria-label="a dense table">
                  <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                    <TableRow style={{ background: '#DAEDFE', width: '100%' }}>
                      <TableCell style={{ fontSize: '12px', padding: '5px 10px', textAlign: 'right', width: '20%', height: '35px' }}>{tr('declaredGoodsValueFrom', 'Declared Goods Value From')}</TableCell>
                      <TableCell style={{ fontSize: '12px', padding: '5px 10px', textAlign: 'right', width: '20%', height: '35px' }}>{tr('declaredGoodsValueTo', 'Declared Goods Value To')}</TableCell>
                      <TableCell style={{ fontSize: '12px', padding: '5px 20px', textAlign: 'left', width: '30%', height: '35px' }}>{tr('percentageOrAmount', 'Percentage / Amount')}</TableCell>
                      <TableCell style={{ fontSize: '12px', padding: '5px 10px', textAlign: 'right', width: '15%', height: '35px' }}>{tr('value', 'Value')}</TableCell>
                      <TableCell style={{ fontSize: '12px', padding: '5px 10px', textAlign: 'left', width: '15%', height: '35px' }}>{tr('gsAction', 'Action')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {editModelRows?.map((val, index) => (
                      <TableRow style={{ width: '100%' }} key={index}>
                        <TableCell style={{ padding: '5px 10px' }}>
                          <Box>
                            <div className={'input--wrapper btmSpaceNotRequired'} style={{ marginBottom: '0px !important' }}>
                              <Lineinput
                                disabled={
                                  index == 0 || (index == 1 && declaredValueCheck == false) || (index == 2 && declaredValueCheck == false)
                                }
                                textAlign={'end'}
                                id={`valueFrom-${index}`}
                                autoFocus={index == 2}
                                // label={requiredLabelTxt(`Sender Name`)}
                                type="text"
                                name="sendName"
                                value={val.GoodsValueFrom || ''}
                                onChange={(e) => handleChangeGoodsValue(e, index)}
                                onBlur={(e) => handleCheckGoodsValue(e, 'GoodsValueFrom', index)}
                                sx={{ margin: '8px', width: '100%' }}
                                onKeyDown={(e) => navigation3(e, `valueTo-${index}`, index == 0 ? "checkValBasedValue" : `docValue-${index - 1}`)}
                              />
                            </div>
                          </Box>
                        </TableCell>
                        <TableCell style={{ padding: '5px 10px' }}>
                          <Box>
                            <div className={'input--wrapper btmSpaceNotRequired'} style={{ marginBottom: '0px !important' }}>
                              <Lineinput
                                disabled={true}
                                textAlign={'end'}
                                id={`valueTo-${index}`}
                                // label={requiredLabelTxt(`Sender Name`)}
                                // type="text"
                                // name="sendName"
                                value={val.GoodsValueTo || ''}
                                // onChange={(e) => setHandleChangeValueTo(e.target.value)}
                                // sx={{ margin: '8px', width: '100%' }}
                                onKeyDown={(e) => navigation3(e, `checkPercent-${index}`, `valueFrom-${index}`)}
                              />
                            </div>
                          </Box>
                        </TableCell>
                        <TableCell style={{ padding: '5px 10px' }}>
                          <Box style={{ display: 'flex' }}>
                            <Box className="topSection-right">
                              <Radio id={`checkPercent-${index}`} checked={val.PerAmount === 1} onKeyDown={(e) => navigation3(e, `checkAmount-${index}`, `valueTo-${index}`)} onChange={() => handleRadioChange('Percentage', index)} name="PerAmount" />
                              <span style={{ fontSize: '12px', fontStyle: 'normal', fontWeight: '500', color: '#444' }}>{tr('inPercentage', 'In Percentage')}</span>
                            </Box>
                            <Box className="topSection-right">
                              <Radio id={`checkAmount-${index}`} checked={val.PerAmount === 2} onKeyDown={(e) => navigation3(e, `docValue-${index}`, `checkPercent-${index}`)} onChange={() => handleRadioChange('Amount', index)} name="PerAmount" />
                              <span style={{ fontSize: '12px', fontStyle: 'normal', fontWeight: '500', color: '#444' }}>{tr('inAmount', 'In Amount')}</span>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell style={{ padding: '5px 10px' }}>
                          <Box>
                            <div className={'input--wrapper btmSpaceNotRequired'} style={{ marginBottom: '0px !important' }}>
                              <Lineinput
                                // disabled={
                                //   index == 0 || (index == 1 && declaredValueCheck == false) || (index == 2 && declaredValueCheck == false)
                                // }
                                disabled={declaredValueCheck == false}
                                textAlign={'end'}
                                id={`docValue-${index}`}
                                value={val.Rate}
                                onChange={(e) => handleChangeRate(e, index)}
                                onKeyDown={(e) => navigation3(e, index == 2 ? `removeBtn-${index}` : editModelRows.length > 2 ? `valueFrom-${index + 1}` : `addBtn-${index}`, `checkAmount-${index}`)}
                              />
                            </div>
                          </Box>
                        </TableCell>
                        <TableCell style={{ padding: '12px 10px', display: 'flex' }}>
                          <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                            <Button
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                '&.MuiButton-root': {
                                  minWidth: 'auto !important',
                                  padding: '6px 2px !important',
                                  textTransform: 'capitalize',
                                },
                                '&.Mui-disabled': {
                                  backgroundColor: 'transparent !important',
                                  border: 'none !important',
                                },
                                '& .MuiButton-startIcon': {
                                  marginRight: '2px !important',
                                },
                              }}
                              id={`addBtn-${index}`}
                              onClick={() => addRow(index)}
                              onKeyDown={(e) => navigation3(e, index == 0 && editModelRows.length > 1 ? `valueFrom-${index + 1}` : index == 0 ? 'valBasedUnit' : `removeBtn-${index}`, `docValue-${index}`, () => { })}
                              // editModelRows.length>0?index`removeBtn-${index}`:`valueFrom-${index+1}`
                              disabled={editModelRows.length >= 3}
                              startIcon={<AddCircleIcon style={{ color: editModelRows.length >= 3 ? '#ccc' : '#0086ff', fontSize: '14px' }} />}
                            >
                              <span
                                className="blue-color-txt"
                                style={{
                                  color: editModelRows.length >= 3 ? '#ccc' : '#0086ff',
                                  textDecoration: 'underline',
                                  fontWeight: 'bold',
                                  fontSize: '12px !important',
                                }}
                              >
                                {tr('gsAdd', 'Add')}
                              </span>
                            </Button>

                            {index !== 0 && editModelRows.length - 1 === index && (
                              <>
                                <span style={{ padding: '0px 2px 2px 2px', fontSize: '14px', fontWeight: 600, color: '#0086FF' }}>|</span>
                                <Button
                                  variant="text"
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    '&.MuiButton-root': {
                                      minWidth: 'auto !important',
                                      padding: '6px 2px !important',
                                      textTransform: 'capitalize',
                                    },
                                    '&.Mui-disabled': {
                                      backgroundColor: 'transparent !important',
                                      border: 'none !important',
                                    },
                                    '& .MuiButton-startIcon': {
                                      marginRight: '2px !important',
                                    },
                                  }}
                                  id={`removeBtn-${index}`}
                                  onClick={() => removeRow(index)}
                                  onKeyDown={(e) => navigation3(e, 'valBasedUnit', `docValue-${index}`, () => { })}
                                  // index==2?`addBtn-${index}`:
                                  startIcon={<RemoveCircleIcon style={{ color: '#0086ff', fontSize: '14px' }} />}
                                >
                                  <span
                                    className="blue-color-txt"
                                    style={{ textDecoration: 'underline', fontWeight: 'bold', fontSize: '12px !important' }}
                                  >
                                    {tr('gsRemove', 'Remove')}
                                  </span>
                                </Button>
                              </>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Stack>
            <Stack style={{ width: '100%', padding: "12px 16px" }}>
              <Box style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
                <Item className="checkbox-ctrl" style={{ width: '100%', padding: "0px" }}>
                  <FormControlLabel
                    id='valBasedUnit'
                    onChange={(e) => handleTotalUnitCheck(e)}
                    // onChange={() => setTotalUnitCheck(!totalUnitCheck)}
                    value="end"
                    control={
                      <Checkbox
                        checked={totalUnitCheck}
                      // sx={{ fontSize:'14px',fontWeight:'700' }}
                      />
                    }
                    // label="Consigner"
                    label={
                      <span style={{ fontSize: '14px', fontWeight: '700', fontStyle: 'normal', lineHeight: '20px', color: '#444' }}>
                        {DefaultCurrencyID ===2?tr('insuranceBasedOnTotalUnits', 'Insurance Based on Total Units'):tr('valuationBasedOnTotalUnits', 'Valuation Based on Total Units')}
                      </span>
                    }
                    labelPlacement="end"
                    onKeyDown={(e) => navigation3(e, "firstUnitValChrg", editModelRows.length == 1 ? `addBtn-0` : editModelRows.length == 2 ? `removeBtn-1` : `removeBtn-2`)}
                  />
                </Item>
              </Box>
            </Stack>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: "12px 16px", width: '100%', borderBottom: '1px solid #DDD' }}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: '0px', width: '47%', gap: '14px' }}>
                <Box
                  sx={{
                    fontSize: '14px',
                    fontWeight: '700',
                    fontStyle: 'normal',
                    lineHeight: '15px',
                    color: '#444'
                  }}
                >
                  {DefaultCurrencyID ===2?tr('firstUnitInsuranceCharges', 'First Unit Insurance Charges:'):tr('firstUnitValuationCharges', 'First Unit Valuation Charges:')}
                </Box>
                <Box className={'input--wrapper'}>
                  <Lineinput
                    disabled={!totalUnitCheck}
                    id={'firstUnitValChrg'}
                    value={valuationChrg}
                    onChange={(e) => setValuationChrg(e.target.value)}
                    onKeyDown={(e) => navigation3(e, 'addiUnitValChrg', "valBasedUnit")}
                  />
                </Box>
              </Box>
              <Box sx={{ display: 'flex', flex: 'end', justifyContent: 'flex-end', alignItems: 'center', padding: '0px', width: '53%', gap: '14px' }}>
                <Box
                  sx={{
                    fontSize: '14px',
                    fontWeight: '700',
                    fontStyle: 'normal',
                    lineHeight: '15px',
                    color: '#444'
                  }}
                >
                  {DefaultCurrencyID ===2?tr('additionalUnitInsuranceCharges', 'Additional Unit Insurance Charges:'):tr('additionalUnitValuationCharges', 'Additional Unit Valuation Charges:')}
                </Box>
                <Box className={'input--wrapper'} >
                  <Lineinput
                    disabled={!totalUnitCheck}
                    id={'addiUnitValChrg'}
                    value={addiValuationChrg}
                    onChange={(e) => setAddiValuationChrg(e.target.value)}
                    onKeyDown={(e) => navigation3(e, 'docActive', "firstUnitValChrg")}
                  />
                </Box>
              </Box>
            </Box>
            <Stack style={{ padding: "6px 16px 6px 16px", width: '100%' }}>
              <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                {declaredValueCheck && totalUnitCheck ? (
                  <Item className="checkbox-ctrl" style={{ display: 'flex', justifyContent: "center", alignItems: 'center', padding: '0px' }}>
                    <p style={{ color: '#0086FF', fontSize: '12px', fontStyle: 'normal', lineHeight: '20px' }}>
                      {DefaultCurrencyID ===2 ? tr('insuranceHigherTip', '* Incase of both, amount whichever is higher will be considered as Insurance Charge.') : tr('valuationHigherTip', '* Incase of both, amount whichever is higher will be considered as Valuation Charge.')}
                    </p>
                  </Item>
                ) : (
                  <Item className="checkbox-ctrl">
                    <p style={{ color: '#0086FF', fontSize: '12px', fontStyle: 'normal', lineHeight: '20px' }}></p>
                  </Item>
                )}
                <Item style={{ display: 'flex', justifyContent: "center", alignItems: 'center', padding: '0px' }}>
                  {
                    !isEdit&&
                  <Item className="checkbox-ctrl">
                    <FormControlLabel
                      value="end"
                      onChange={() => setAllBranchCheck(!allBranchCheck)}
                      control={
                        <Checkbox
                          id={'docActive'}
                          checked={allBranchCheck}
                          // sx={{ marginLeft: '8px' }}
                          onKeyDown={(e) => navigation3(e, "saveBtn", 'addiUnitValChrg')}
                        />
                      }
                      // label="Consigner"
                      label={
                        <span style={{ fontSize: '14px', fontWeight: '700', fontStyle: 'normal', lineHeight: 'normal', color: '#444' }}>
                          {tr('configureForAllBranches', 'Configure For All Branches')}
                        </span>
                      }
                      labelPlacement="end"
                    />
                  </Item>
                   }
                  <Item className="checkbox-ctrl">
                    <FormControlLabel
                      value="end"
                      onChange={() => setIsActive(!isActive)}
                      control={
                        <Checkbox
                          id={'docActive'}
                          checked={isActive}
                          // sx={{ marginLeft: '8px' }}
                          onKeyDown={(e) => navigation3(e, "saveBtn", 'addiUnitValChrg')}
                        />
                      }
                      // label="Consigner"
                      label={
                        <span style={{ fontSize: '14px', fontWeight: '700', fontStyle: 'normal', lineHeight: 'normal', color: '#444' }}>
                          {DefaultCurrencyID ===2?tr('activeInsuranceCharge', 'Active Insurance Charge'):tr('activeValuationCharge', 'Active Valuation Charge')}
                        </span>
                      }
                      labelPlacement="end"
                    />
                  </Item>
                  <Item sx={sx.itemsx} style={{ height: '41px' }} className="disabled-wrapper" >
                    <Button id='saveBtn' variant="contained" className="valuationbtn gobtn-primary" onClick={() => saveValuationCharge()} onKeyDown={(e) => navigation3(e, 'selectBranch', "docActive", () => { saveValuationCharge(); focusElemnt('contains-1') })}>
                      {isEdit ? tr('gsUpdate', 'UPDATE') : tr('gsSave', 'SAVE')}
                    </Button>
                  </Item>
                </Item>
              </Box>
            </Stack>
          </>
        }
      </Modal>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, getGSInsuranceInsertUpadate, updateAlertError, getBookingConsType, getGSBranchValuationDetailsTableData }
export default connect(mapStateToProps, mapDispatchToProps)(CreateEditValuationChrge)